exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "covance-tooltip ::ng-deep div[tooltip-content] {\n  font-style: normal;\n}\n\ndiv[result-content] {\n  padding-right: 2px;\n}\n\nspan.cancelled-result {\n  vertical-align: middle;\n}\n\n.deltaindicator {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n", ""]);

// exports
